import React, { FC } from 'react';
import { ReactComponent as WheelsLightIcon } from '../../../../assets/images/repairWorks/wheelsIconLight.svg';
import { ReactComponent as WheelsDarkIcon } from '../../../../assets/images/repairWorks/wheelsIconDark.svg';
import { useAppSelector } from '../../../../hooks/redux';

interface WheelsIconProps {
  className?: string;
}

const defaultProps = {
  className: '',
};

export const WheelsIcon: FC<WheelsIconProps> = ({ className }) => {
  const { theme } = useAppSelector((state) => state.appReducer);

  const getIcon = (colorTheme: string) => {
    switch (true) {
      case colorTheme === 'light': {
        return <WheelsLightIcon className={className} />;
      }
      case colorTheme === 'dark': {
        return <WheelsDarkIcon className={className} />;
      }
      default: {
        return <WheelsLightIcon className={className} />;
      }
    }
  };
  return getIcon(theme);
};

WheelsIcon.defaultProps = defaultProps;
